import React from 'react';
import { Seo } from '/src/components';
import NavHeader from '/src/components/nav-header';
import MailingList from '/src/components/mailing-list';
import PageFooter from '/src/components/v2/page-footer';
import {
	Splash,
	Featured,
	DriverApp,
	ExploreDriverCloud,
	TheCloud,
	DashCamWants,
	RoadSafety,
	Accessible,
	Reviews,
	Pricing,
	HandsFree,
	AboutUs,
	AAOSFeatures,
	CompanionApp,
} from '/src/screens/home';

const HomePage = () => {
	return (
		<div id="home-page">
			<Seo title="Driver" />
			<NavHeader />
			<Splash />
			{/* <Featured />
			<DriverApp />
			<RoadSafety />
			<ExploreDriverCloud />
			<TheCloud />
			<DashCamWants />
			<Accessible />
			<Reviews />
			<Pricing />
			<HandsFree />
			<AboutUs />
			<MailingList />
			<PageFooter /> */}
			<ExploreDriverCloud />
			<AAOSFeatures />
			<CompanionApp />
			<Featured />
			<DriverApp />
			<RoadSafety />
			<Pricing />
			<HandsFree />
			<Reviews />
			<Accessible />
			<AboutUs />
			<MailingList />
			<PageFooter />
		</div>
	);
};

export default HomePage;
